import { useEffect, useState } from "react";
import { fetchBooks } from "../lib/api";
import { BookCard } from "../components/BookCard";
import { BookDetailDialog } from "../components/BookDetailDialog";

export default function Nouveautes() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchBooks({ is_new: true })
      .then((data) => {
        setBooks(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-nouveautes" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen">
      <header className="mb-20 max-w-4xl">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">
          Dernières publications
        </p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#1A1A1A] leading-[1.05] tracking-tight font-light mb-8">
          Nouveautés <em className="text-[#2C402E]">2026</em>
        </h1>
        <p className="text-lg text-[#4A4A4A] font-body leading-relaxed max-w-2xl">
          Découvrez nos publications les plus récentes. Des œuvres fraîchement
          sorties de presse, sélectionnées pour vous accompagner dans vos prochaines
          lectures.
        </p>
      </header>

      {loading ? (
        <p className="text-[#757575] font-body" data-testid="loading-nouveautes">Chargement…</p>
      ) : books.length === 0 ? (
        <p className="text-[#757575] font-body" data-testid="no-nouveautes">Aucune nouveauté pour le moment.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {books.map((book, i) => (
            <BookCard key={book.id} book={book} index={i} onClick={() => setSelected(book)} />
          ))}
        </div>
      )}
      <BookDetailDialog book={selected} open={!!selected} onClose={() => setSelected(null)} />
    </div>
  );
}
